"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
exports.default = react_1.default.memo(Emoji);
const useStyles = makeStyles_1.default((theme) => ({
    emoji: {
        height: 20,
        fontSize: 20,
        lineHeight: 1
    }
}));
function Emoji(props) {
    const classes = useStyles();
    return react_1.default.createElement("span", { className: classes.emoji }, props.text);
}
